import { getUserProperty } from '@atlassian/jira-common-rest/src/api/latest/user-properties';
import { FetchError } from '@atlassian/jira-fetch';
import { type AccountId, toBaseUrl } from '@atlassian/jira-shared-types';

import { PANEL_STATE_KEY } from '../../../constants';
import type { StoreActions, PanelState } from '../../types';

export const initializeState =
	(atlassianAccountId: AccountId) =>
	async ({ setState, getState }: StoreActions) => {
		try {
			const res: PanelState = await getUserProperty(
				toBaseUrl(''),
				atlassianAccountId,
				PANEL_STATE_KEY,
			);
			setState({ ...getState(), panelState: res });
		} catch (error) {
			// 404 means this user property hasn't been set, meaning user hasn't dismissed/minimised it
			if (error instanceof FetchError && error.statusCode === 404) {
				setState({ ...getState(), panelState: 'open' });
			} else {
				setState({ ...getState(), panelState: 'dismissed' });
			}
			// When erroring out, treat it as dismissed
		}
	};
